import { Circle } from "lucide-react";
import { siteContent } from "@/data/siteContent";

export const CommunitySection = () => {
  const { community } = siteContent;

  return (
  <section className="section-shell" aria-labelledby="community-title" data-testid="community-section">
    <div className="site-container community-layout">
      <div>
        <h2 id="community-title" className="section-title section-title--compact" data-testid="community-title">
          {community.heading}
        </h2>
        <p className="section-intro" data-testid="community-intro">
          {community.copy}
        </p>
      </div>
      <div className="community-principles" data-testid="community-principles">
        {community.items.map((item, index) => (
          <div className="community-principle" key={item} data-testid={`community-principle-${index + 1}`}>
            <Circle size={9} fill="currentColor" aria-hidden="true" /> {item}
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};